const Asian_2=[
    {
        "type":"Contig",
        "MAX":"217540000",
        "N10":"217540000",
        "N20":"217540000",
        "N30":"114577180",
        "N40":"114577180",
        "N50":"111386608",
        "N60":"97559953",
        "N70":"85641709",
        "N80":"68621336",
        "N90":"61012511",
        "MIN":"58881387"
    },
    {
        "type":"Scaffold",
        "MAX":"217540000",
        "N10":"217540000",
        "N20":"217540000",
        "N30":"114577180",
        "N40":"114577180",
        "N50":"111386608",
        "N60":"97559953",
        "N70":"85641709",
        "N80":"68621336",
        "N90":"61012511",
        "MIN":"58881387"
    }
]
export default Asian_2